<template>
  <v-ons-page>
    <v-ons-toolbar modifier="transparent"></v-ons-toolbar>
    <div class="page__background page--material__background"></div>
    <div class="header">
      <div class="logo-menu">
        <img src="../assets/logo-ifacare-white.png" />
      </div>
      <div class="close-menu">
        <v-ons-icon icon="fa-times"></v-ons-icon>
      </div>
      <!-- <div class="title-account">
        <span class="font-weight-semibold"
          >{{
            $store.state.user.name != ""
              ? $store.state.user.app_detail.app_name
              : ""
          }}
          {{
            $store.state.user.name != ""
              ? "/ " + $store.state.user.app_detail.package
              : ""
          }}</span
        >
        <span v-show="$store.state.user.name != ''"></span>
        <p class="m-b-0 m-t-0">
          {{ $store.state.user.name }}
        </p>
      </div> -->
    </div>

    <div class="custom-sidebar">
      <!-- ====================== VVIP Member ============================== -->

      <div class="sidebar-vvip" v-if="profileArr.member_membership == 'vvip'">
        <v-ons-lis>
          <v-ons-list-item
            v-for="(menuArr, index) in getListMenu"
            :key="index"
            @click="goTo(`${menuArr.name}`)"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon"></v-ons-icon>
            </div>
            <div class="center">{{ menuArr.meta.title }}</div>

            <div class="right">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon1"></v-ons-icon>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="$store.state.user.token" @click="logout">
            <div class="left">
              <v-ons-icon fixed-width icon="sign-out-alt"></v-ons-icon>
            </div>
            <div class="center">Logout</div>
          </v-ons-list-item>
          <v-ons-list-header>SLA</v-ons-list-header>
          <v-ons-list-item
            v-for="item in essentialLinks"
            @click="goToExternal(item.link)"
            :key="item.link"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="item.icon"></v-ons-icon>
            </div>
            <div class="center">{{ item.label }}</div>
          </v-ons-list-item>
        </v-ons-lis>
      </div>

      <!-- ====================== Premium Member ============================== -->
      <div
        class="sidebar-premium"
        v-if="profileArr.member_membership == 'premium'"
      >
        <v-ons-lis>
          <v-ons-list-item
            v-for="(menuArr, index) in getListMenu"
            :key="index"
            @click="goTo(`${menuArr.name}`)"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon"></v-ons-icon>
            </div>
            <div class="center">{{ menuArr.meta.title }}</div>

            <div class="right">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon1"></v-ons-icon>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="$store.state.user.token" @click="logout">
            <div class="left">
              <v-ons-icon fixed-width icon="sign-out-alt"></v-ons-icon>
            </div>
            <div class="center">Logout</div>
          </v-ons-list-item>
          <v-ons-list-header>SLA</v-ons-list-header>
          <v-ons-list-item
            v-for="item in essentialLinks"
            @click="goToExternal(item.link)"
            :key="item.link"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="item.icon"></v-ons-icon>
            </div>
            <div class="center">{{ item.label }}</div>
          </v-ons-list-item>
        </v-ons-lis>
      </div>
      <!-- ====================== Free Member ============================== -->
      <div class="sidebar-free" v-if="profileArr.member_membership == 'umum'">
        <v-ons-lis>
          <v-ons-list-item
            v-for="(menuArr, index) in getListMenu"
            :key="index"
            @click="goTo(`${menuArr.name}`)"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon"></v-ons-icon>
            </div>
            <div class="center">{{ menuArr.meta.title }}</div>

            <div class="right">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon1"></v-ons-icon>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="$store.state.user.token" @click="logout">
            <div class="left">
              <v-ons-icon fixed-width icon="sign-out-alt"></v-ons-icon>
            </div>
            <div class="center">Logout</div>
          </v-ons-list-item>
          <v-ons-list-header>SLA</v-ons-list-header>
          <!-- <v-ons-list-item
            v-for="item in essentialLinks"
            @click="goToExternal(item.link)"
            :key="item.link"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="item.icon"></v-ons-icon>
            </div>
            <div class="center">{{ item.label }}</div>
          </v-ons-list-item> -->
        </v-ons-lis>
      </div>
    </div>
    <div class="custom-sidebar" v-if="profileArr.member_type == 'pasien'">
      <div class="default-sidebar">
        <v-ons-list>
          <v-ons-list-item
            v-for="(menuArr, index) in getListMenu"
            :key="index"
            @click="goTo(`${menuArr.name}`)"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon"></v-ons-icon>
            </div>
            <div class="center">{{ menuArr.meta.title }}</div>

            <div class="right">
              <v-ons-icon fixed-width :icon="menuArr.meta.icon1"></v-ons-icon>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="$store.state.user.token" @click="logout">
            <div class="left">
              <v-ons-icon fixed-width icon="sign-out-alt"></v-ons-icon>
            </div>
            <div class="center">Logout</div>
          </v-ons-list-item>
          <v-ons-list-header>SLA</v-ons-list-header>
          <v-ons-list-item
            v-for="item in essentialLinks"
            @click="goToExternal(item.link)"
            :key="item.link"
          >
            <div class="left">
              <v-ons-icon fixed-width :icon="item.icon"></v-ons-icon>
            </div>
            <div class="center">{{ item.label }}</div>
          </v-ons-list-item>
        </v-ons-list>
      </div>
    </div>
    <v-ons-list>
      <v-ons-list-item>
        <div style="margin:5px;font-size:12px;">
          <p class="m-b-0 m-t-0">{{ APP_NAME }}</p>
          <p class="m-t-0">{{ APP_VERSION }}</p>
        </div>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
import { constantRoutes } from "@/router";
export default {
  name: "menuPage",
  data() {
    return {
      essentialLinks: [
        {
          label: "Bantuan 24/7",
          link: "https://inolabs.freshdesk.com/support/solutions/42000065106",
          icon: "fa-commenting"
        }
      ],
      APP_NAME: process.env.APP_NAME,
      APP_VERSION: process.env.APP_VERSION,
      listMenu: []
    };
  },
  mounted() {
    // console.log(process.env.APP_NAME);
  },
  computed: {
    getListMenu() {
      const allRoutes = this.$store.state.permission.routes;
      const hasToken = this.$store.state.user.token;
      this.listMenu = [];
      // console.log('allRoutes', allRoutes)
      if (allRoutes) {
        allRoutes.forEach(route => {
          if (hasToken) {
            if (route.meta && route.meta.roles && route.hidden == false) {
              this.listMenu.push(route);
            }
          }
        });
      }
      // console.log('this.listMenu', this.listMenu)
      return this.listMenu;
    },

    profileArr() {
      return this.$store.state.user.profileArr;
    }
  },
  methods: {
    goTo(pathName) {
      const matched = this.$route.matched;
      const routePath = matched[matched.length - 1].path;
      const currentPathName = matched[matched.length - 1].name;
      // console.log('matched', matched)
      // console.log('routePath', routePath)
      if (currentPathName != pathName) {
        this.$router.push({ name: pathName });
      }
      this.$store.dispatch("onsen/updateToggle", false);
    },
    goToExternal(url) {
      // this.$router.push({name: 'Tentang'})
      this.$store.dispatch("onsen/updateToggle", false);
      window.open(url, "_blank");
    },
    async logout() {
      this.listMenu = await [];
      await this.$store.dispatch("onsen/updateToggle", false);
      // await this.$store.dispatch("user/logout");
      await this.$store.dispatch("user/logoutAll");
      // await this.updateMenu
      // console.log('updateMenu', updateMenu)

      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      this.$router.push(`/home?redirect=${this.$route.fullPath}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  /* background-color: #38ae47; */
  background: linear-gradient(
    120deg,
    #2cba80 0%,
    #73b063 25%,
    #96aa53 50%,
    #aea54a 75%,
    #d59f3b 100%
  );
  padding: 20px 16px 16px 16px;
  /* width: 268px; */
  border-radius: 0 0 0px 0px;
  display: flex;
  justify-content: space-between;
}
.header .fa {
  color: #fff;
}
.logo-menu img {
  display: block;
  margin: auto auto 20px auto;
  width: 214px;
  height: 75px;
}
/* img {
  max-width: 150px;
} */

ons-list-title {
  text-transform: none;
}

ons-list-item {
  cursor: pointer;
}
.title-account {
  font-size: 13px;
  color: #ffff;
}
.page--material__background {
  background-color: #ffffff !important;
}
.list-item {
  color: #424242;
}
ons-icon {
  color: #38ae47;
  /* color: #9e9e9e; */
}
</style>
<style>
.toolbar--material__left {
  min-width: 35px;
}
.page--material__background {
  background-color: #eeeeee;
}
hr.hr-solid {
  border-top: 0.5px solid #e0e0e0;
  border-bottom: 0.5px solid #e0e0e0;
}
hr.hr-dashed {
  /* border-top: 0.75px dashed #e0e0e0; */
  border-top: 0px dashed #e0e0e0;
  border-bottom: 0.75px dashed #e0e0e0;
}
hr.hr-dashed-white {
  border-top: 0.75px dashed #ffffff;
  border-bottom: 0.75px dashed #ffffff;
}

ons-splitter-side
  .toolbar.toolbar--material
  + .page__background
  + .page__content {
  top: 0;
}
ons-splitter-side .list-item--material__left {
  min-width: 40px;
}

.link {
  color: #979797;
}
.link:focus {
  color: #50b755;
}
.font-weight-semibold {
  font-weight: 600;
}
.text-success {
  color: #50b755;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-input--material:focus {
  background-image: linear-gradient(#50b755, #50b755),
    linear-gradient(to top, transparent 1px, #afafaf 1px) !important;
}
.toolbar-button--material {
  color: #464646;
  font-size: 18px;
}
.toolbar--material__center {
  color: #464646;
  font-weight: 600 !important;
  font-size: 17px;
}
.text-input--material__label--active {
  /* color: #979797; */
  color: #36ad45;
}

ons-splitter-mask {
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}
.m-b-0 {
  margin-bottom: 0;
}
.m-b-1 {
  margin-bottom: 10px;
}
.m-t-1 {
  margin-top: 10px;
}
.m-t-2 {
  margin-top: 20px;
}
.m-b-2 {
  margin-bottom: 20px;
}
.m-t-0 {
  margin-top: 0;
}
.m-l-col-card {
  margin-left: 4px;
}
.m-r-col-card {
  margin-right: 4px;
}
.list-item--material__left:empty,
.list-item--material__center {
  padding: 14px 16px 14px 0;
}
.list-item-no-icon .list-item--material__center {
  padding: 14px 16px 14px 16px;
}
.list-item-no-icon .list-item__center {
  padding: 12px 12px 12px 12px;
}
.list-item-no-icon .list-item {
  padding: 0 0 0 0;
}

.sidebar-vvip .list-item:nth-of-type(9) {
  display: none;
}

.sidebar-free .list-item:nth-of-type(3),
.sidebar-free .list-item:nth-of-type(6),
.sidebar-free .list-item:nth-of-type(8) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuPage.vue